import React, { useState } from "react";
import hire from "../../../assets/images/hire.jpg";
import ContactUs from "./ContactUs";
import Modal from "../Modal";

function RecurtBanner() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return (
    <div
      className="relative bg-cover bg-center flex items-center justify-center text-center px-6 md:px-12 lg:px-24 py-16 md:py-24 lg:py-32"
      style={{ backgroundImage: `url(${hire})` }}
    >
      {/* Overlay */}
      {/* <div className="!absolute inset-0"></div> */}

      {/* Content */}
      <div className=" max-w-3xl text-white space-y-6 ">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white">
          Assemble Your Elite Tech Team at Zero Cost
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl font-medium">
          Build Your Tech Dream Team
        </p>
        <p className="text-sm sm:text-md md:text-lg text-justify">
          Leverage cost-free recruitment to simplify your hiring process and build a top-tier tech team effortlessly. SmikRecruit connects you with a handpicked pool of skilled, industry-ready professionals across Data Analytics, Data Science, AI/ML, Software Development, DevOps, UI/UX Design, Cybersecurity, and Product Management. Start assembling your ideal team with SmikRecruit today!
        </p>
        <button onClick={openModal} className="bg-orange-500 text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-orange-600 transition" >
          Start Hiring
        </button>
      </div>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <div className="flex items-center justify-content-between bg-[#0e63e2] rounded-md mb-2 py-3">
            <p className="text-white font-bold text-xl pl-3">Contact Us</p>
          </div>
          <div className="bg-white w-[100%] h-[88%] rounded-lg shadow-lg relative overflow-auto">
            <ContactUs />
          </div>
        </Modal>
      )}
    </div>
  );
}

export default RecurtBanner;
